import React from 'react';
import { Chip } from '@mui/material';
import { WaveStatus } from '../../services/fulfillment/types';

interface WaveStatusChipProps {
  status: WaveStatus;
  waveId: number | null;
}

const WaveStatusChip: React.FC<WaveStatusChipProps> = ({ status, waveId }) => {
  if (status === 'exception') return <Chip label="Exception" size="small" color="error" />;
  if (status === 'in_wave') return <Chip label={`Wave #${waveId}`} size="small" color="primary" />;
  return <Chip label="No wave" size="small" />;
};

export default WaveStatusChip;
